import EstimateIconOutlined from "@/components/icons/EstimateIconOutlined";
import SwitchWithLabel from "@/components/SwitchWithLabel/SwitchWithLabel";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Form } from "antd";
import styles from "./Modal.module.scss";

export default function EstimationSwitch() {
  return (
    <div className={styles.estimation}>
      <div className={styles.estimationWrapper}>
        <span className={styles.estimationTitle}>Totals unknown?</span>
        <div className={styles.estimationToggle}>
          <EstimateIconOutlined />
          <Form.Item
            name="estimation"
            noStyle={true}
            valuePropName={"checked"}
          >
            <SwitchWithLabel
              togglePosition="right"
              size="small"
            >
              Setup estimation
            </SwitchWithLabel>
          </Form.Item>
        </div>
      </div>
      <div className={styles.estimationExplanation}>
        <InfoCircleOutlined className={styles.estimationHelpIcon} />
        <div>
          The product mass will be automatically recalculated based on your orders and bill of
          materials, which auto-updates your 'total consumption estimate'.
        </div>
      </div>
    </div>
  );
}
